"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
/**
 * @hidden
 */
var PDFMargin = /** @class */ (function (_super) {
    __extends(PDFMargin, _super);
    function PDFMargin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFMargin.prototype.render = function () {
        return null;
    };
    PDFMargin.propTypes = {
        left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    };
    return PDFMargin;
}(React.Component));
exports.PDFMargin = PDFMargin;
//# sourceMappingURL=PDFMargin.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-react-pdf/dist/npm/PDFMargin.js
// module id = 344
// module chunks = 0